import { componentHeights } from "../../index"
const { nav, footer, navV2, footer2 } = componentHeights

const appStyles = {
	appPadding: {
		padding: { zero: "0px 15px", xs2: "0px 25px" }
	},

	container: {
		width: "100%",
		minHeight: "100vh",
		alignItems: "center",
		flexWrap: "nowrap",
		background:'transparent'
	},

	containerV2: {
		width: "100%",
		minHeight: "100vh",
		alignItems: "center",
		flexWrap: "nowrap",

		"*": {
			boxSizing: "border-box"
		}
	},

	pageContainer: {
		width: "100%",
		minHeight: `calc(100vh - ${navV2} - ${footer2})`,
		justifyContent: "space-between",
		alignItems: "center",
		flexWrap: "nowrap"
	},

	routeContainer: {
		width: "100%",
		minHeight: `calc(100vh - ${nav} - ${footer})`,
		margin: `${nav} 0px 0px`,
		justifyContent: "flex-start",
		alignItems: "center",
		flexWrap: "nowrap"
	},

	routeContainerV2: {
		width: "100%",
		padding: "50px 0px",
		justifyContent: "flex-start",
		alignItems: "center",
		flexWrap: "nowrap"
	}
}

export default appStyles
